import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import FormGroup from 'components/Form/FormGroup';
import StaticText from 'components/Form/StaticText';
import App from 'modules/App';
import messages from '../../../messages';
const Field = ({ id, formValues })=>/*#__PURE__*/ _jsx(FormGroup, {
        id: id,
        labelMessage: messages.labels[id] || App.messages.labels[id],
        formValues: formValues,
        isOneLiner: true,
        children: /*#__PURE__*/ _jsx(StaticText, {})
    });
export default Field;
